<template>
  <div class="ihe-container">
    <div class="header" :style="{backgroundImage: `url(${row.image3})`}">
      <div class="ihe-widget text-center">
        <div class="bg-title white-color" v-html="row.title3"></div>
        <div class="ihe-bg-color" :style="{backgroundColor: `${row.bgColor3} !important`}">
          <div class="text mb-3 white-color" v-html="row.body3"></div>
          <router-link v-if="row.button3" :to="row.redirect3" class="m-ins-btn" v-html="row.button3"></router-link>
        </div>
      </div>
      <div class="gradient-easing"></div>
    </div>
  </div>
</template>

<style scoped>
.ihe-container {
  padding-top: 60px;
}
.header {
  height: 540px;
  background-size: cover;
  position: relative;
  background-position: center center;
}
.ihe-widget {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.ihe-bg-color {
  padding: 36px 15px
}
.bg-title {
  font-size: 50px;
  margin-bottom: 27px;
}
.text {
  font-size: 17px;
  line-height: 1.5;
}
.bg-title,
.text,
.m-ins-btn {
  position: relative;
  z-index: 5;
}
.m-ins-btn {
  border: 1px solid #fff;
  color: #fff;
  padding: 7px 20px;
  font-size: 20px;
  line-height: 1;
  display: inline-block;
}
.m-ins-btn:hover {
  background: #fff;
  color: #000;
}
.m-ins-btn:active {
  opacity: 0.6;
}
.gradient-easing {
  height: 500px !important;
  position: absolute;
  bottom: 0;
  width: 100%;
  background-image: linear-gradient( rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.00709) 10.47%, rgba(0, 0, 0, 0.02755) 19.56%, rgba(0, 0, 0, 0.06016) 27.58%, rgba(0, 0, 0, 0.1037) 34.81%, rgba(0, 0, 0, 0.15697) 41.57%, rgba(0, 0, 0, 0.21875) 48.13%, rgba(0, 0, 0, 0.28782) 54.79%, rgba(0, 0, 0, 0.36296) 61.85%, rgba(0, 0, 0, 0.44297) 69.61%, rgba(0, 0, 0, 0.52662) 78.36%, rgba(0, 0, 0, 0.6127) 88.39%, rgba(0, 0, 0, 0.7) );
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 4;
}
</style>

<script>
export default {
  name: "Section3",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
